import React from 'react';
import Input from '../elements/Input';

const KeyContactsForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="Contact Name"
      value={formData.name || ''}
      onChange={e => setFormData({ ...formData, name: e.target.value })}
      placeholder="e.g. Rahul Sharma, Priya Patel, Dr. Mehta"
      error={formError.name}
    />
    <Input
      label="Relationship"
      value={formData.relationship || ''}
      onChange={e => setFormData({ ...formData, relationship: e.target.value })}
      placeholder="e.g. Family friend, Lawyer, Accountant"
      error={formError.relationship}
    />
    <Input
      label="Phone Number"
      type="tel"
      value={formData.phone || ''}
      onChange={e => setFormData({ ...formData, phone: e.target.value })}
      placeholder="e.g. +91-9876543210, 022-12345678"
      error={formError.phone}
    />
    <Input
      label="Email"
      type="email"
      value={formData.email || ''}
      onChange={e => setFormData({ ...formData, email: e.target.value })}
      placeholder="e.g. contact@lawfirm.com, abc.xyz@email.com"
      error={formError.email}
    />
    <Input
      label="Notes / Details"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="Enter any additional notes or details"
      error={formError.notes}
    />
  </>
);

export default KeyContactsForm;